var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"third-sub-nav"},[_c('ul',{staticClass:"sub-nav-box clearfix"},_vm._l((_vm.navList),function(nav,index){return _c('li',{key:index,staticClass:"sub-nav-item",class:{
          pre: nav.targetRouterName === _vm.$route.name,
        }},[_c('nav-link-item',{attrs:{"sub":"","nav":nav}})],1)}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }